module["exports"] = [];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/address/state.js
// module id = 1331
// module chunks = 0